import { kebabCase } from 'lodash';

const cache = new Map<HTMLElement, Map<string, string>>();

function assertElement(element: Element | undefined | null): asserts element is HTMLElement {
  if (!(element instanceof HTMLElement)) {
    throw new Error('🚫 Whoops! Element has to be an instance of HTMLElement');
  }
}

export function set(element: Element | undefined | null, styles: React.CSSProperties) {
  assertElement(element);
  const originalStyles = new Map<string, string>();

  Object.entries(styles).forEach(([key, value]) => {
    const originalValue = element.style.getPropertyValue(kebabCase(key));
    originalStyles.set(key, originalValue);
    element.style.setProperty(kebabCase(key), value);
  });

  cache.set(element, originalStyles);
}

export function remove(element: Element | undefined | null, props: Array<keyof React.CSSProperties>) {
  assertElement(element);
  props.forEach((prop) => {
    element.style.removeProperty(kebabCase(prop));
  });
}

export function reset(element: Element | undefined | null, props?: Array<keyof React.CSSProperties>) {
  assertElement(element);
  const originalStyles = cache.get(element);

  if (!originalStyles) {
    return;
  }

  if (props !== undefined) {
    const styles = props.map((prop) => {
      const value = originalStyles.get(prop);

      if (!value) {
        return [prop, ''];
      }

      return [prop, value];
    });

    styles.forEach(([key, value]) => {
      element.style.setProperty(kebabCase(key), value);
    });

    return;
  }

  [...originalStyles.entries()].forEach(([key, value]) => {
    element.style.setProperty(kebabCase(key), value);
  });
}
